<template>
  <font-awesome-icon
    icon="building"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBuilding } from '@fortawesome/free-solid-svg-icons'

library.add(faBuilding)

export default {
  name: 'CoozzyBuildingIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
